/**
 * Shared previewability guard for `.eml` (message/rfc822) attachments.
 *
 * Single source of truth consumed by BOTH the server preview route and the
 * client Reader chip, so the two can never drift on what counts as previewable.
 * Runtime-only util — the type-only contract lives in `./types`.
 */

/** RFC822 media type for an embedded message. */
const EML_CONTENT_TYPE = "message/rfc822";
/** Filename suffix for a saved email message. */
const EML_SUFFIX = ".eml";

/**
 * True when an attachment is a previewable embedded message: its contentType is
 * `message/rfc822` OR its filename ends in `.eml` — both matched
 * case-insensitively. Any other attachment is download-only.
 */
export function isEmlAttachment(contentType: string, filename: string): boolean {
  const normalizedType = (contentType.split(";")[0] ?? "").trim().toLowerCase();
  if (normalizedType === EML_CONTENT_TYPE) return true;
  return filename.trim().toLowerCase().endsWith(EML_SUFFIX);
}
